<template>
  <div class="error-page">
    <div class="http403-container">
      <div class="wscn-http403">
        <p class="pic-403">403</p>
        <div class="bullshit">
          <p class="bullshit__oops">{{ $t("undefined.authority.warn") }}</p>
          <p class="bullshit__headline">{{ $t("undefined.authority.permission") }}</p>
          <p class="bullshit__info">{{ $t("undefined.authority.relation") }}</p>
          <router-link to="/" class="linkTo">
            <el-button type="primary" size="small" round>{{ $t("undefined.common.back") }}</el-button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Authority",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.error-page {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  position: relative;
}
.http403-container {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 45%;
  left: 50%;
}
.pic-403 {
  font-size: 200px;
  text-align: center;
  font-weight: bold;
  color: #1482f0;
  letter-spacing: 5px;
}
.bullshit {
  padding: 20px 0 30px;
  overflow: hidden;
  text-align: center;
}
.bullshit__oops {
  font-size: 32px;
  line-height: 40px;
  color: #1482f0;
  margin-bottom: 40px;
  animation-fill-mode: forwards;
  font-weight: 700;
}
.bullshit__headline {
  font-size: 20px;
  line-height: 24px;
  color: #222;
  margin-bottom: 10px;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
  font-weight: 700;
}
.bullshit__info {
  font-size: 13px;
  line-height: 21px;
  color: grey;
  margin-bottom: 30px;
  animation-delay: 0.2s;
  animation-fill-mode: forwards;
}
</style>
